export default "__VITE_ASSET__e47edb7f__"